/**
 * Phase 0 world-format public contract.
 *
 * This module intentionally exports contract data and TypeScript interfaces only.
 * Implementations remain in separate modules; this file is the public type and
 * constant authority.
 */
export const WORLD_FORMAT_V1 = Object.freeze({
    blockCatalogVersion: 1,
    chunkSizeX: 16,
    chunkSizeZ: 16,
    generatorVersion: 1,
    seaLevel: 48,
    subchunkSize: 16,
    subchunksPerColumn: 8,
    worldFormatVersion: 1,
    worldHeight: 128,
    worldMaxChunkX: 7,
    worldMaxChunkZ: 7,
    worldMaxX: 127,
    worldMaxY: 127,
    worldMaxZ: 127,
    worldMinChunkX: -8,
    worldMinChunkZ: -8,
    worldMinX: -128,
    worldMinY: 0,
    worldMinZ: -128,
});
export const PLACEABLE_BLOCK_IDS_V1 = Object.freeze([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
]);
export const BLOCK_CATALOG_V1 = Object.freeze([
    Object.freeze({ id: 0, stableKey: "air", solid: false, replaceable: true, modifiable: false, placeable: false, renderClass: "none", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 0, soundSet: 0 }),
    Object.freeze({ id: 1, stableKey: "meadow_grass", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "opaque", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 1, soundSet: 1 }),
    Object.freeze({ id: 2, stableKey: "warm_soil", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "opaque", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 2, soundSet: 1 }),
    Object.freeze({ id: 3, stableKey: "island_stone", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "opaque", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 3, soundSet: 2 }),
    Object.freeze({ id: 4, stableKey: "pale_sand", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "opaque", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 4, soundSet: 3 }),
    Object.freeze({ id: 5, stableKey: "soft_snow", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "opaque", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 5, soundSet: 4 }),
    Object.freeze({ id: 6, stableKey: "clear_water", solid: false, replaceable: true, modifiable: true, placeable: true, renderClass: "water", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 6, soundSet: 5 }),
    Object.freeze({ id: 7, stableKey: "garden_path", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "opaque", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 7, soundSet: 2 }),
    Object.freeze({ id: 8, stableKey: "hewn_timber", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "opaque", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 8, soundSet: 6 }),
    Object.freeze({ id: 9, stableKey: "sunwashed_plank", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "opaque", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 9, soundSet: 6 }),
    Object.freeze({ id: 10, stableKey: "hearth_brick", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "opaque", sameClassCullMode: "same-render-class", emissive: 0, atlasSlot: 10, soundSet: 2 }),
    Object.freeze({ id: 11, stableKey: "mist_glass", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "glass", sameClassCullMode: "exact-block-id", emissive: 0, atlasSlot: 11, soundSet: 7 }),
    Object.freeze({ id: 12, stableKey: "glowstone_tile", solid: true, replaceable: false, modifiable: true, placeable: true, renderClass: "opaque", sameClassCullMode: "same-render-class", emissive: 12, atlasSlot: 12, soundSet: 2 }),
]);
